import React, { useEffect, useState } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import CropImageField from '@components/common/form/CropImageField';
import CropImageFieldNoCrop from '@components/common/form/CropImageField/CropImageFieldNoCrop';
import UploadImageField from '@components/common/form/UploadImageField';
import apiConfig from '@constants/apiConfig';
import useBasicForm from '@hooks/useBasicForm';
import useFetch from '@hooks/useFetch';
import useTranslate from '@hooks/useTranslate';
import { BaseForm, TextField } from '@itz/react-cms-element';
import { getBase64 } from '@utils';
import { Card, Col, Form, Row } from 'antd';

const messages = defineMessages({
    image: 'Image',
    groupFoodName: 'Group Food Name',
});

const InwenChildForm = (props) => {
    const { formId, dataDetail, onSubmit, setIsChangedFormValues, actions } = props;
    const [ imageUrl, setImageUrl ] = useState(null);
    const translate = useTranslate();
    const { execute: executeUpFile } = useFetch(apiConfig.file.upload);
    const { form, mixinFuncs, onValuesChange } = useBasicForm({
        onSubmit,
        setIsChangedFormValues,
    });

    const queryParams = new URLSearchParams(location.search);
    const parentId = queryParams.get('parentId');

    const handleUploadImage = (file, onSuccess) => {
        getBase64(file, (image) => {
            form.setFieldsValue({ inwenMediaLibraryData: image.split(',')[1] });
            setImageUrl(image);
            onSuccess();
        });
    };

    // const uploadFile = (file, onSuccess, onError) => {
    //     executeUpFile({
    //         data: {
    //             type: 'AVATAR',
    //             file: file,
    //         },
    //         onCompleted: (response) => {
    //             if (response.result === true) {
    //                 onSuccess();
    //                 setImageUrl(response.data.filePath);
    //                 setIsChangedFormValues(true);
    //             }
    //         },
    //         onError: (error) => {
    //             onError();
    //         },
    //     });
    // };

    useEffect(() => {
        form.setFieldsValue({
            ...dataDetail,
        });
        setImageUrl(
            dataDetail.inwenMediaLibraryData ? `data:image/png;base64,${dataDetail.inwenMediaLibraryData}` : '',
        );
    }, [ dataDetail ]);

    // useEffect(() => {
    //     form.setFieldsValue({
    //         ...dataDetail,
    //     });
    //     setImageUrl(dataDetail.accountDto?.avatar);
    // }, [dataDetail]);

    const uploadFile = (file, onSuccess, onError) => {
        getBase64(file, (base64Image) => {
            if (base64Image.startsWith('data:image')) {
                setImageUrl(base64Image);
            } else {
                setImageUrl(`data:image/png;base64,${base64Image}`);
            }
        });
    };

    const handleFinish = (values) => {
        values.parentId = parentId;
        mixinFuncs.handleSubmit({
            ...values,
            inwenMediaLibraryData: imageUrl?.split(',')[1],
        });
    };

    return (
        <BaseForm id={formId} onFinish={handleFinish} form={form} onValuesChange={onValuesChange}>
            <Card className="card-form" bordered={false}>
                <Form
                    id={formId}
                    form={form}
                    layout="vertical"
                    onFinish={handleFinish}
                    onValuesChange={onValuesChange}
                    initialValues={{
                        ...dataDetail,
                    }}
                >
                    <Row gutter={16}>
                        <Col span={12}>
                            {/* <UploadImageField
                            fieldName="inwenMediaLibraryData"
                            //loading={imageUploading}
                            //label={tInwens('label.image')}
                            imageUrl={imageUrl}
                            //onChange={this.handleChangeImage}
                            //uploadFile={this.uploadFileImage}
                            // requiredMsg="Please enter logo"
                            imgUploadedSizeAuto
                            required
                            accept=".png"
                            imageStyles={{
                                backgroundColor: '#232935',
                                objectFit: 'contain',
                            }}
                        /> */}
                            {/* <CropImageField
                            label={<FormattedMessage defaultMessage="Image" />}
                            name="avatar"
                            imageUrl={imageUrl && `${AppConstants.contentRootUrl}${imageUrl}`}
                            aspect={1 / 1}
                            uploadFile={uploadFile}
                        /> */}
                            <CropImageFieldNoCrop
                                label={<FormattedMessage defaultMessage="Image" />}
                                name="inwenMediaLibraryData"
                                // imageUrl={imageUrl && `${AppConstants.contentRootUrl}${imageUrl}`}
                                imageUrl={imageUrl}
                                aspect={1 / 1}
                                uploadFile={uploadFile}
                                required
                            />
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <TextField
                                label={<FormattedMessage defaultMessage="Name" />}
                                name="inwenMediaLibraryName"
                                required
                            />
                        </Col>
                    </Row>

                    <div className="footer-card-form">{actions}</div>
                </Form>
            </Card>
        </BaseForm>
    );
};

export default InwenChildForm;
